import cx from "clsx";
import React from "react";

import styles from "./index.module.scss";

interface IClassName {
  className?: string;
  style?: React.CSSProperties;
}

function VerticalDivider({ className, style }: IClassName) {
  return <hr className={cx(styles.verticalDivider, className)} style={style} />;
}

function HorizontalDivider({ className, style }: IClassName) {
  return (
    <hr className={cx(styles.horizontalDivider, className)} style={style} />
  );
}

const Decorators = {
  VerticalDivider,
  HorizontalDivider,
};

export default Decorators;
